<template>
  <header>
    <!-- <div v-if="showPromotion" class="promotion__container">
      <p>FREE SHIPPING ON ORDERS OVER $50</p>
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="showPromotion = false"
      >
        <path
          d="M0.758057 11.243L6.00106 6L11.2441 11.243M11.2441 0.757L6.00006 6L0.758057 0.757"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div> -->
    <div class="container">
      <nav class="top__navigation">
        <router-link to="/">
          <img src="../assets/images/logo.png" class="logo" alt="logo" />
        </router-link>

        <div class="nav__links" :class="{ activeNav: showSideNav }">
          <router-link @click="hideNav" to="/cart" class="desktop-cart">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              fill="currentColor"
              class="bi bi-bag"
              viewBox="0 0 16 16"
            >
              <path
                d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z"
              />
            </svg>
            <div class="qty" v-if="cart.length >= 1">
              <span>{{ cart.length }}</span>
            </div>
          </router-link>

          <template v-if="!isLoggedIn">
            <!-- Desktop auth links -->
            <router-link @click="hideNav" to="/login" class="auth-link desktop-only"
              >Login
            </router-link>
            <router-link @click="hideNav" to="/signup" class="auth-link desktop-only">
              <action-button>Sign Up</action-button>
            </router-link>

            <!-- Mobile auth dropdown toggle -->
            <button
              aria-label="mobile auth"
              @click="showAuthDropDown = !showAuthDropDown"
              class="nav-profile mobile-auth"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1em"
                height="1em"
                fill="currentColor"
                class="bi bi-person"
                viewBox="0 0 16 16"
              >
                <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                <path d="M14 14s-1-1.5-6-1.5S2 14 2 14s1-4 6-4 6 4 6 4z"/>
              </svg>

              <div
                class="dropdown"
                v-if="showAuthDropDown"
                @mouseleave="showAuthDropDown = !showAuthDropDown"
              >
                <router-link
                  @click="showAuthDropDown = false"
                  to="/login"
                  class="dropdown-link"
                  aria-label="Login"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1em"
                    height="1em"
                    fill="currentColor"
                    class="bi bi-box-arrow-in-right"
                    viewBox="0 0 16 16"
                  >
                    <path fill-rule="evenodd" d="M6 3a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-1h1v1h7V3H7v1H6V3z"/>
                    <path fill-rule="evenodd" d="M11.5 8a.5.5 0 0 0-.5-.5H3.707l1.147-1.146a.5.5 0 1 0-.708-.708l-2 2a.5.5 0 0 0 0 .708l2 2a.5.5 0 1 0 .708-.708L3.707 8.5H11a.5.5 0 0 0 .5-.5z"/>
                  </svg>
                  <span>Login</span>
                </router-link>
                <router-link
                  @click="showAuthDropDown = false"
                  to="/signup"
                  class="dropdown-link"
                  aria-label="Sign Up"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1em"
                    height="1em"
                    fill="currentColor"
                    class="bi bi-person-plus"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                    <path d="M1 14s1-4 7-4 7 4 7 4H1z"/>
                    <path fill-rule="evenodd" d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"/>
                  </svg>
                  <span>Sign Up</span>
                </router-link>
              </div>
            </button>
          </template>

          <template v-else-if="isLoggedIn">
            <button
              aria-label="desktop logout"
              @click="showDropDown = !showDropDown"
              class="nav-profile"
            >
              <img :src="getHash" :alt="this.userDetails?.displayName" />

              <div
                class="dropdown"
                v-if="showDropDown"
                @mouseleave="showDropDown = !showDropDown"
              >
                <div class="dropdown-profile">
                  <span>Signed in as</span>
                  <span class="dropdown-name">{{
                    this.userDetails?.displayName
                  }}</span>
                </div>
                <router-link
                  :to="{ name: 'shop' }"
                  class="dropdown-link"
                  aria-label="Go to shop"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1em"
                    height="1em"
                    fill="currentColor"
                    class="bi bi-box-arrow-up-right"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
                    />
                    <path
                      fill-rule="evenodd"
                      d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"
                    />
                  </svg>
                  <span>Go to Shop</span>
                </router-link>
                <router-link 
                  :to="{ name: 'account' }"
                  class="dropdown-link"
                  aria-label="Go to account"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1em"
                    height="1em"
                    fill="currentColor"
                    class="bi bi-person dropdown-account"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM8 9a5 5 0 0 0-4.546 2.916C3.224 13.482 4.385 14 8 14s4.776-.518 4.546-2.084A5 5 0 0 0 8 9z"/>
                  </svg>
                  <span>My Account</span>
                </router-link>
                <router-link
                  v-if="isAdmin"
                  :to="{ name: 'overview' }"
                  class="dropdown-link admin-link"
                  aria-label="Go to admin panel"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1em"
                    height="1em"
                    fill="currentColor"
                    class="bi bi-shield-lock"
                    viewBox="0 0 16 16"
                  >
                    <path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"/>
                    <path d="M9.5 6.5a1.5 1.5 0 0 1-1 1.415l.385 1.99a.5.5 0 0 1-.491.595h-.788a.5.5 0 0 1-.49-.595l.384-1.99a1.5 1.5 0 1 1 2-1.415z"/>
                  </svg>
                  <span>Admin Panel</span>
                </router-link>
                <button
                  @click="logout"
                  class="dropdown-link"
                  aria-label="Logout"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1em"
                    height="1em"
                    fill="currentColor"
                    class="bi bi-power dropdown-logout"
                    viewBox="0 0 16 16"
                  >
                    <path d="M7.5 1v7h1V1h-1z" />
                    <path
                      d="M3 8.812a4.999 4.999 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812z"
                    />
                  </svg>
                  <span>Logout</span>
                </button>
              </div>
            </button>
          </template>
        </div>

        <!-- <div class="mobile-menu">
          <router-link to="/cart" class="mobile-cart" aria-label="Go to cart">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              fill="currentColor"
              class="bi bi-bag"
              viewBox="0 0 16 16"
            >
              <path
                d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z"
              />
            </svg>
            <div class="qty" v-if="cart.length >= 1">
              <span>{{ cart.length }}</span>
            </div>
          </router-link>

          <svg
            @click="showNav"
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="currentColor"
            class="bi bi-list open-btn"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
            />
          </svg>
        </div> -->
      </nav>
    </div>
    <div
      class="nav__container"
      :class="{ 'nav__container--hidden': !showNavbar }"
    >
      <!-- <router-link @click="hideNav" to="/">Home</router-link> -->
      <router-link @click="hideNav" to="/about">OUR PROCESS</router-link>
      <router-link @click="hideNav" to="/shop">PRODUCTS</router-link>
      <router-link @click="hideNav" to="/contact">OUR STORY</router-link>
    </div>
  </header>
</template>

<script>
import { auth } from "@/firebase/init.js";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { mapState, mapActions, mapGetters } from "vuex";
import ActionButton from "./ActionButton.vue";
import { User } from "@/firebase/userServices";

export default {
  components: { ActionButton },
  name: "MainHeader",
  props: {
    msg: String,
  },
  data() {
    return {
      isLoggedIn: false,
      showSideNav: false,
      showDropDown: false,
      showAuthDropDown: false,
      isAdmin: false,
      userDetails: {
        displayName: null,
        email: null,
        emailVerified: false,
        isAnonymous: false,
      },
      showPromotion: true,
      showNavbar: true,
      lastScrollPosition: 0,
    };
  },
  methods: {
    ...mapActions(["remove_user"]),
    showNav() {
      this.showSideNav = true;
    },
    hideNav() {
      this.showSideNav = false;
    },
    async logout() {
      try {
        await signOut(auth);
        this.$router.push("/");
        this.isLoggedIn = false;
        console.log("User signed out");
      } catch (error) {
        console.error("Error signing out: ", error.message);
      }
    },

    onScroll() {
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      if (currentScrollPosition < 0) {
        return;
      }
      // Stop executing this function if the difference between
      // current scroll position and last scroll position is less than some offset
      if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
        return;
      }
      this.showNavbar = currentScrollPosition < this.lastScrollPosition;
      this.lastScrollPosition = currentScrollPosition;
    },
  },
  mounted() {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        this.isLoggedIn = true;
        console.log("is logged in? ", this.isLoggedIn);
        console.log("user:", user);

        this.userDetails.displayName = user.displayName;
        this.userDetails.email = user.email;
        this.userDetails.emailVerified = user.emailVerified;
        this.userDetails.isAnonymous = user.isAnonymous;
        
        // Check if user is admin
        await User.getUser(user.uid);
        this.isAdmin = await User.isAdminAsync();
        console.log('Is admin?', this.isAdmin);
      } else {
        this.isLoggedIn = false;
        this.isAdmin = false;
        this.userDetails = {
          displayName: null,
          email: null,
          emailVerified: false,
          isAnonymous: false,
        };
      }
    });
    window.addEventListener("scroll", this.onScroll);
  },
  computed: {
    ...mapState(["user", "cart"]),
    ...mapGetters(["getHash"]),
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
header {
  background-color: transparent;

  position: sticky;
  top: 0;
  width: 100%;
  z-index: 999;
}

.container {
  background-color: var(--cosmic-latte);
  width: 100%;
  max-width: none;
  position: relative;
  z-index: 999;
}

.top__navigation {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 85px;
}

.logo {
height: 10rem;
}

.nav__links a,
.log-out {
  padding-inline: 15px;
  font-size: 1.8rem;
  font-weight: 600;
  color: var(--dark-blue);
  transition: all 0.25s ease-in-out;
  line-height: 2rem;
}

.nav__links .log-out {
  background-color: transparent;
}

a.active__page,
.nav__links a:hover,
.mobile-menu a:hover {
  color: var(--dark-blue);
}

.nav__links {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 4rem;
}

.nav__links a::after,
.mobile-menu a::after {
  content: "";
  display: block;
  position: relative;
  top: 2px;
  height: 2px;
  left: 0;
  width: 0;
  background-color: var(--dark-blue);
  border-radius: 6px;
  transition: width 0.25s ease;
}

.nav__links a:hover::after,
.mobile-menu a:hover::after {
  width: 70%;
}

.nav__links a.router-link-exact-active::after {
  width: 70%;
}

.nav__links .auth-link::after,
.dropdown .dropdown-link::after {
  display: none;
}

.desktop-cart {
  display: initial;
  position: relative;
}

.qty {
  height: 18px;
  width: 18px;
  text-align: center;
  display: flex;
  justify-content: center;
  border-radius: 50%;
  background-color: var(--dark-blue);
  font-size: 14px;
  color: white;
  font-weight: 500;
  position: absolute;
  top: -4px;
  right: 4px;
}

.nav-profile {
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  margin-left: 15px;
  background: transparent;
}

/* hidden by default; shown only on small screens */
.mobile-auth {
  display: none;
}

.nav-profile img {
  width: 35px;
  height: 35px;
  border-radius: 50%;
}

.nav-profile .name {
  font-size: 1.8rem;
}

.nav-profile svg {
  font-size: 1.8em;
  cursor: pointer;
  font-weight: 900;
}

.dropdown {
  background-color: white;
  z-index: 2;
  border-radius: 8px;
  border: 1px solid var(--grey-2);
  position: absolute;
  top: 35px;
  right: 0;
  transition: 0.25s;
  width: 170px;
}

.dropdown-profile {
  padding: 10px;
  font-size: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-bottom: 1px solid var(--grey-2);
}

.dropdown svg {
  font-size: 1.6rem;
  cursor: pointer;
  font-weight: 900;
}

.dropdown .dropdown-logout {
  font-size: 1.7rem;
}

.dropdown .dropdown-link {
  font-size: 1.6rem;
  color: #222;
  background-color: transparent;
  padding: 10px;
  width: 100%;
  transition: background-color 0.25s;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 18px;
  font-weight: 400;
}

.dropdown .dropdown-link:hover {
  color: var(--dark-green);
}

.dropdown .admin-link {
  background: linear-gradient(135deg, #fef3c7 0%, #fffef9 100%);
  border-top: 1px solid #f59e0b;
  border-bottom: 1px solid #f59e0b;
  color: #f59e0b;
  font-weight: 600;
}

.dropdown .admin-link:hover {
  background: linear-gradient(135deg, #fde68a 0%, #fef3c7 100%);
  color: #d97706;
}

.dropdown-name {
  font-weight: 500;
}

/* Media Query */

@media (max-width: 460px) {
  .nav__links {
    right: 0;
    width: 100%;
    padding: 0 2rem;
    justify-content: space-between;
  }

  /* hide desktop auth links on small screens */
  .desktop-only {
    display: none;
  }

  /* show mobile auth icon button */
  .mobile-auth {
    display: flex;
  }
}

@media (max-width: 870px) {
  /* show desktop auth links on larger screens only */
  .desktop-only {
    display: none;
  }

  .mobile-auth {
    display: flex;
  }

  .mobile-menu {
    display: flex;
    gap: 1.5rem;
    color: var(--text);
  }

  .mobile-menu svg {
    cursor: pointer;
    font-size: 2rem;
  }

  .mobile-menu .open-btn {
    font-size: 2.4rem;
    font-weight: 900;
  }

  /* .nav__links {
    align-items: flex-start;
    justify-content: flex-start;
    gap: 2.2rem;
    flex-direction: column;
    position: fixed;
    top: 0;
    right: -55%;
    width: 55%;
    z-index: 2;
    padding: 2rem 3rem;
    background-color: white;
    height: 100%;
    box-shadow: 0 40px 60px rgba(0, 0, 0, 0.1);
    transition: 0.25s;
  } */

  .activeNav {
    right: 0;
  }

  .nav__links a,
  .log-out {
    padding: 0.5rem 0;
    font-size: 1.8rem;
  }

  .nav__links a:hover::after {
    width: 2.5rem;
  }

  .nav__links a.router-link-exact-active::after {
    width: 2.5rem;
  }

  .close-btn {
    display: initial;
  }

  .mobile-cart {
    position: relative;
    z-index: 1;
  }
  .qty {
    align-items: center;
  }
  .log-out {
    display: initial;
  }
}

.promotion__container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background-color: #b22100;
  padding: 0 3rem;
  height: 40px;
}
.promotion__container p {
  color: #fff;
  padding-block: 0;
  margin: 0;
  line-height: 1;
  font-size: 14px;
  font-weight: 600;
}

.nav__container {
  height: 45px;
  background-color: #2b2118;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 45px;
  transition: 0.35s all ease-out;
  z-index: 1;

  @media screen and (min-width: 652px) {
    gap: 100px;
  }
  @media screen and (min-width: 1200px) {
    gap: 150px;
  }
}
.nav__container a {
  font-size: 14px;
  font-weight: 700;
  color: #fff;
}
.nav__container.nav__container--hidden {
  box-shadow: none;
  transform: translate3d(0, -100%, 0);
}

.nav__container a:hover {
  color: var(--text);
}
</style>
